var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.587 7.925l-18.41 18.41-6.764-6.765a.84.84 0 00-1.188 0l-1.979 1.98a.84.84 0 000 1.187l9.338 9.338a.84.84 0 001.187 0l20.983-20.983a.84.84 0 000-1.187l-1.98-1.98a.84.84 0 00-1.187 0z"
  })));
}
export default SvgCheckmark;